import SuggestedRouteType from "@Route/types/SuggestedRoute.type";
import RouteType from "@Route/types/Route.type";
import IntermodalRouteType from "@Intermodal/types/IntermodalRoute.type";

export const isSuggestedRoute = (route: RouteType|IntermodalRouteType|SuggestedRouteType): route is SuggestedRouteType => (route?.isSuggestedRoute)